import { createFileRoute } from '@tanstack/react-router'
import ContactRetailer from 'Contact/components/Contact/Sections/ContactRetailer'

export const Route = createFileRoute('/contact/$contactId/retailer')({
    component: ContactRetailer,
})
